import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const FleetManagement = React.lazy(async () => ({
    default: (await import('@oc/fleet-management/module')).FleetManagementModule
}))

export function FleetManagementComponent() {
    return <SuspenseWhileLoading LazyComponent={FleetManagement} />
}
